import { Link, useSearchParams } from "react-router-dom";
import { useConfig, waLink } from "@/context/ConfigContext";
import { useSeo } from "@/lib/useSeo";
import { Button } from "@/components/ui/button";
import { CheckCircle2, MessageCircle } from "lucide-react";

export default function ThankYou() {
  useSeo({ title: "Thank You | Maha Sampada", description: "Thank you for reaching out to Maha Sampada." });
  const [params] = useSearchParams();
  const config = useConfig();
  const type = params.get("type") || "query";
  const ref = params.get("ref");

  const content = {
    query: {
      heading: "Thank You for Your Query",
      body: "Your travel enquiry has been received. Our destination team will review the requirement and get back to you with a customized proposal shortly.",
    },
    partner: {
      heading: "Welcome to Maha Sampada",
      body: "Thank you for registering with Maha Sampada. Our Partner Relations team will contact you shortly.",
    },
    contact: {
      heading: "Message Received",
      body: "Thank you for contacting Maha Sampada. We will respond to your message as soon as possible.",
    },
    provider: {
      heading: "Thank You for Your Interest",
      body: "Thank you for your interest in working with Maha Sampada. Our team will review the information and contact you if your services align with our current requirements. Submission of this form does not constitute approval, empanelment or a contractual relationship.",
    },
  }[type] || {};

  return (
    <div className="flex min-h-[85vh] items-center justify-center bg-cream px-4 py-24">
      <div className="w-full max-w-lg rounded-3xl border border-gold/25 bg-white p-10 text-center fade-up">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-forest/10"><CheckCircle2 className="h-9 w-9 text-forest" /></div>
        <h1 data-testid="thank-you-heading" className="mt-6 font-display text-3xl font-bold text-charcoal">{content.heading}</h1>
        {ref && (
          <div className="mt-4 inline-block rounded-full bg-saffron/10 px-5 py-2">
            <span className="font-accent text-xs text-muted-foreground">Your reference: </span>
            <span data-testid="enquiry-reference" className="font-accent text-sm font-bold text-saffron">{ref}</span>
          </div>
        )}
        <p className="mt-5 text-sm leading-relaxed text-muted-foreground">{content.body}</p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link to="/"><Button variant="outline" className="w-full rounded-full border-charcoal font-accent hover:bg-charcoal hover:text-white sm:w-auto">Back to Home</Button></Link>
          {waLink(config.whatsapp) && <a href={waLink(config.whatsapp)} target="_blank" rel="noopener noreferrer">
            <Button className="w-full rounded-full bg-forest font-accent text-white hover:bg-forest/90 sm:w-auto"><MessageCircle className="mr-2 h-4 w-4" />Chat on WhatsApp</Button>
          </a>}
        </div>
      </div>
    </div>
  );
}
